<template>
  <div id="c1-gigya-container"></div>
  <div v-if="isNewPassModalOpen">
    <NewPasswordModal @modal-action="modalAction"></NewPasswordModal>
  </div>
</template>

<script setup>
const config = useRuntimeConfig();
const router = useRouter();
const route = useRoute();

let isModalSubmitted = ref(false);
let isNewPassModalOpen = useState('is-new-pass-modal-open', () => false);
const emit = defineEmits(['modal-action']);

definePageMeta({
  layout: 'user-reg-login-layout',
  middleware: ['page-redirection']
});

onMounted(() => {
  if (window['gigya']) {
    initGigyaScreen(
      '',
      config.public.gigyaScreens[route.path],
      'c1-gigya-container'
    );
  } else {
    window.addEventListener('gigyaLoaded', () =>
      initGigyaScreen(
        '',
        config.public.gigyaScreens[route.path],
        'c1-gigya-container'
      )
    );
  }
  window.addEventListener('GIGYA_AFTER_SCREEN_LOAD', handleAfterScreenLoad);
});

const handleAfterScreenLoad = (data) => {
  if (data.detail.event.currentScreen == 'nemo-reset-password') {
    const savePasswordInput = document.querySelector(
      '#c1-gigya-container #gigya-reset-password-form .gigya-input-submit'
    );
    if (savePasswordInput) {
      savePasswordInput.addEventListener('click', (event) => {
        if (!isModalSubmitted.value) {
          isNewPassModalOpen.value = true;
          event.preventDefault();
          event.stopPropagation();
        }
        isModalSubmitted.value = false;
      });
    }
  }
};
onBeforeUnmount(() => {
  isModalSubmitted.value = false;
  isNewPassModalOpen.value = false;
});

const modalAction = (action) => {
  isNewPassModalOpen.value = false;
  if (action === 'cancel') {
    router.push({
      path: `/login`
    });
  } else {
    isModalSubmitted.value = true;
    document
      .querySelector(
        '#c1-gigya-container #gigya-reset-password-form .gigya-input-submit'
      )
      .click();
  }
};
</script>
